<dx-popup
    #adjustmentDetailPopup
    [title]="popUpTitle"
    [showTitle]="true"
    [minWidth]="'50%'"
    [minHeight]="'50%'"
    [resizeEnabled]="true"
    [(visible)]="visible"
    (onHidden)="onHidden($event)"
>
    <div *dxTemplate="let item of 'content'" class="adjustment-detail-content">
        <dx-box *ngIf="!!adjustmentDetail" width="100%" height="100%" direction="col">
            <dxi-item baseSize="auto">
                <dx-form
                    width="100%"
                    height="100%"
                    [readOnly]="true"
                    [colCount]="3"
                    [labelLocation]="defaultLabelLocation"
                    [formData]="adjustmentDetail"
                >
                    <dxi-item [colSpan]="2">
                        <dxo-label text="Adjustment Type"></dxo-label>
                        <div *dxTemplate>
                            {{ adjustmentDetail?.debitOrCredit }}
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1">
                        <div class="history-icon" *dxTemplate>
                            <dx-toolbar>
                                <dxi-item location="after" *ngIf="adjustmentDetail?.hasCreditApplications">
                                    <div *dxTemplate>
                                        <app-hyperlink-creator
                                            cssClass="cc-text-bold"
                                            displayText="Payment Applications"
                                            (onLinkClick)="onPaymentApplicationClick()"
                                        ></app-hyperlink-creator>
                                    </div>
                                </dxi-item>
                                <dxi-item location="after">
                                    <div *dxTemplate>
                                        <!-- Note: As discussed and confirmed with Sandeep on 28/06/2024. Like V1, adjustment details will show attachment viewer irrespective of their role -->
                                        <app-attachment-editor
                                            *ngIf="!!adjustmentDetail?.arAdjustmentId"
                                            [viewOnly]="true"
                                            [allowBulkSave]="true"
                                            [communityId]="adjustmentDetailParam.communityId"
                                            [attachments]="attachmentsData"
                                            (onSaveAttachments)="onSaveAttachments($event)"
                                        ></app-attachment-editor>
                                    </div>
                                </dxi-item>
                                <dxi-item location="after" *ngIf="isInternalUser">
                                    <div *dxTemplate>
                                        <dx-button
                                            [icon]="iconHistory"
                                            hint="Transaction History"
                                            (onClick)="onTransactionLogClick()"
                                        ></dx-button>
                                    </div>
                                </dxi-item>
                            </dx-toolbar>
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="3">
                        <dxo-label text="Description"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-box [readOnly]="true" [value]="adjustmentDetail?.description"></dx-text-box>
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1">
                        <dxo-label text="Document Date"></dxo-label>
                        <div *dxTemplate>
                            {{ adjustmentDetail?.docDate | date: dateFormat }}
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1">
                        <dxo-label text="Post Date"></dxo-label>
                        <div *dxTemplate>
                            {{ adjustmentDetail?.postDate | date: dateFormat }}
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1" isRequired="true">
                        <!-- * mark is in ASP application -->
                        <dxo-label text="Sub Ledger"></dxo-label>
                        <div *dxTemplate>
                            {{ adjustmentDetail?.subLedger }}
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1">
                        <dxo-label text="Charge"></dxo-label>
                        <div *dxTemplate>
                            {{ adjustmentDetail?.amount | ccCurrency }}
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1">
                        <dxo-label text="Charge Due"></dxo-label>
                        <div *dxTemplate>
                            <span *ngIf="!adjustmentDetail?.allowCreditApplications">
                                {{ adjustmentDetail?.openBalance | ccCurrency }}
                            </span>

                            <div *ngIf="adjustmentDetail?.allowCreditApplications">
                                <app-hyperlink-creator
                                    [displayText]="adjustmentDetail?.openBalance | ccCurrency"
                                    (onLinkClick)="showARManualCreditApplication()"
                                ></app-hyperlink-creator>
                            </div>
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1">
                        <dxo-label text="Last Updated by"></dxo-label>
                        <div *dxTemplate>
                            <app-user-bio-link
                                [user]="adjustmentDetail?.lastUpdated"
                                [communityId]="adjustmentDetailParam?.communityId"
                            ></app-user-bio-link>
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="3">
                        <dxo-label text="Customer Name"></dxo-label>
                        <div *dxTemplate>
                            <div *ngIf="adjustmentDetail?.customerCode && adjustmentDetailParam?.communityId">
                                <app-hyperlink-creator
                                    mode="hyperlinkOnly"
                                    [displayText]="adjustmentDetail?.customerName"
                                    (onLinkClick)="onCustomerNameClick(adjustmentDetail)"
                                ></app-hyperlink-creator>
                            </div>
                            <span *ngIf="!adjustmentDetail?.customerCode && !adjustmentDetailParam?.communityId">
                                {{ adjustmentDetail?.customerName }}
                            </span>
                        </div>
                    </dxi-item>

                    <dxi-item [colSpan]="3" *ngIf="!!adjustmentDetail.writeOffInfoDisplayText">
                        <div *dxTemplate>
                            <span class="cc-text-required">
                                <strong>Note:</strong>
                                &nbsp;{{ adjustmentDetail?.writeOffInfoDisplayText }}
                            </span>
                        </div>
                    </dxi-item>
                    <dxi-item
                        [colSpan]="3"
                        *ngIf="!!adjustmentDetail.message && !adjustmentDetail.writeOffInfoDisplayText"
                    >
                        <div *dxTemplate>
                            <span class="cc-text-required message-detail">
                                <strong>Note:</strong>
                                &nbsp;
                                <div
                                    [innerHTML]="getHtmlNote(adjustmentDetail) | ccSafeHtml"
                                    (click)="onMessageDetailClick(adjustmentDetail)"
                                ></div>
                            </span>
                        </div>
                    </dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item [ratio]="1" class="adjustment-details-datagrid-content">
                <cc-data-grid-features
                    [stateConfig]="{ storageKey: 'ADJUSTMENT_DETAILS_GRID' }"
                    [gridFeatures]="{ placement: 'top', allowPlacementSwitch: false }"
                    [pagingConfig]="{ visible: false }"
                    [dataSource]="adjustmentDetail?.items"
                >
                    <dx-data-grid
                        width="100%"
                        height="100%"
                        [showBorders]="true"
                        [showRowLines]="true"
                        [showColumnLines]="true"
                        [wordWrapEnabled]="true"
                        [rowAlternationEnabled]="false"
                        [columnAutoWidth]="true"
                        [dataSource]="adjustmentDetail?.items"
                    >
                        <dxi-column
                            caption="Item #"
                            dataType="string"
                            alignment="right"
                            cellTemplate="itemNoTemplate"
                            width="4%"
                        ></dxi-column>
                        <dxi-column
                            caption="Account"
                            dataType="string"
                            cellTemplate="accountTemplate"
                            width="30%"
                        ></dxi-column>
                        <ng-container *ngIf="adjustmentDetail?.entityUsesSubCategory">
                            <dxi-column
                                caption="Sub Category"
                                dataType="string"
                                dataField="subCategory"
                                cellTemplate="subCategoryTemplate"
                                width="10%"
                            ></dxi-column>
                        </ng-container>
                        <dxi-column
                            caption="Amount"
                            dataType="number"
                            dataField="amount"
                            [format]="currencyFormat"
                            width="9%"
                        ></dxi-column>
                        <dxi-column
                            caption="Open Balance"
                            dataType="number"
                            dataField="openBalance"
                            [format]="currencyFormat"
                            width="8%"
                        ></dxi-column>
                        <ng-container *ngFor="let dim of adjustmentDetail?.requiredDimensions">
                            <dxi-column
                                [caption]="dim.displayText"
                                dataType="string"
                                [dataField]="dim.key"
                            ></dxi-column>
                        </ng-container>
                        <ng-container *ngIf="hasOtherDimensions">
                            <dxi-column
                                caption="Other Dimensions"
                                dataType="string"
                                cellTemplate="dimensionTemplate"
                                width="15%"
                            ></dxi-column>
                        </ng-container>
                        <dxi-column
                            caption="Description"
                            dataType="string"
                            dataField="description"
                            width="15%"
                        ></dxi-column>
                        <div *dxTemplate="let row of 'itemNoTemplate'">
                            <span>{{ row.rowIndex + 1 }}</span>
                        </div>
                        <div *dxTemplate="let row of 'accountTemplate'">
                            <ng-container *ngIf="row.data.accountLabelTitle">
                                Account Label:
                                <strong>{{ row.data.accountLabelTitle }}</strong>
                                <br />
                                GL Account Number:
                                <strong>{{ row.data.glAccountNumberTitle }}</strong>
                                <br />
                                Offset GL Account:
                                <strong>{{ row.data.offsetGLAccountNumberTitle }}</strong>
                            </ng-container>
                            <ng-container *ngIf="!row.data.accountLabelTitle">
                                GL Account Number:
                                <strong>{{ row.data.glAccountNumberTitle }}</strong>
                                <br />
                                Offset GL Account:
                                <strong>{{ row.data.offsetGLAccountNumberTitle }}</strong>
                            </ng-container>
                        </div>
                        <div *dxTemplate="let row of 'dimensionTemplate'">
                            <ng-container *ngFor="let dim of row.data.dimensions">
                                <ng-container *ngIf="isNotRequiredDimension(dim)">
                                    {{ dim.dimensionTitle }}: {{ dim.dimensionOptionTitle }}
                                    <br />
                                </ng-container>
                            </ng-container>
                        </div>

                        <div *dxTemplate="let row of 'subCategoryTemplate'">
                            {{ row.data.subCategory }}
                        </div>
                        <dxo-summary [calculateCustomSummary]="calculateCustomSummary">
                            <dxi-total-item
                                name="amount"
                                showInColumn="amount"
                                summaryType="custom"
                                dataType="number"
                                displayFormat="Total: {0}"
                                [valueFormat]="currencyFormat"
                            ></dxi-total-item>
                        </dxo-summary>
                    </dx-data-grid>
                </cc-data-grid-features>
            </dxi-item>
            <dxi-item baseSize="auto">
                <dx-toolbar width="100%">
                    <dxi-item location="after" [visible]="adjustmentDetail?.allowReverse">
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                text="Reverse"
                                hint="Reverse"
                                [icon]="iconReverse"
                                (onClick)="onReverseClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after" [visible]="adjustmentDetail?.allowWriteOff">
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                text="Write Off"
                                hint="Write Off"
                                [icon]="iconWriteOff"
                                (onClick)="onWriteOffClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item
                        location="after"
                        [visible]="!adjustmentDetail?.allowEdit && adjustmentDetail?.allowBasicEdit"
                    >
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                [icon]="iconEdit"
                                text="Basic Edit"
                                (onClick)="onBasicEditClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>

                    <dxi-item location="after" [visible]="adjustmentDetail?.allowEdit">
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                [icon]="iconEdit"
                                text="Edit"
                                (onClick)="onEditClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after" [visible]="adjustmentDetail?.allowDelete">
                        <div *dxTemplate>
                            <dx-button
                                type="danger"
                                [icon]="iconDelete"
                                text="Delete"
                                (onClick)="onDeleteClick(adjustmentDetail)"
                            ></dx-button>
                        </div>
                    </dxi-item>

                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                [icon]="iconCancel"
                                text="Close"
                                (onClick)="onHidden($event)"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#adjustmentDetailPopup' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<app-transaction-history
    *ngIf="displayTransactionLogPopUp"
    [title]="transactionLogTitle"
    [transactionLogResultData]="transactionLogResultData"
    [communityId]="adjustmentDetailParam.communityId"
    (onTransactionLogClose)="onTransactionLogClose($event)"
></app-transaction-history>

<app-ar-credit-application
    *ngIf="showCreditApplication"
    [visible]="showCreditApplication"
    [creditApplicationData]="creditApplicationData"
    [transactionType]="transactionType"
    [transactionId]="adjustmentDetailParam.adjustmentId"
    [communityId]="adjustmentDetailParam.communityId"
    [managementCompanyId]="adjustmentDetailParam.managementCompanyId"
    (onCreditApplicationClose)="closeCreditApplication($event)"
></app-ar-credit-application>

<app-ar-manual-credit-application
    *ngIf="showManualCreditApplication"
    [visible]="showManualCreditApplication"
    [transactionType]="transactionType"
    [transactionId]="adjustmentDetailParam.adjustmentId"
    [communityId]="adjustmentDetailParam.communityId"
    [managementCompanyId]="adjustmentDetailParam.managementCompanyId"
    (onManualCAEditorClose)="onManualCAEditorClose($event)"
></app-ar-manual-credit-application>

<app-ar-adjustment-reverse-editor
    *ngIf="showReverseEditor"
    [visible]="showReverseEditor"
    [arAdjustmentParam]="adjustmentDetailParam"
    (onReverseEditorClose)="onReverseEditorClose($event)"
></app-ar-adjustment-reverse-editor>

<app-ar-adjustment-write-off-editor
    *ngIf="showWriteOffEditor"
    [visible]="showWriteOffEditor"
    [arAdjustmentParam]="adjustmentDetailParam"
    [arAdjustmentItems]="arAdjustmentItems"
    (onWriteOffEditorClose)="onWriteOffEditorClose($event)"
></app-ar-adjustment-write-off-editor>

<app-ar-adjustment-editor
    *ngIf="showARAdjustmentEditor"
    [visible]="showARAdjustmentEditor"
    [popupTitle]="arAdjustmentEditorTitle"
    [isEdited]="true"
    [isLimitedEdit]="isLimitedEdit"
    [arAdjustmentParam]="adjustmentDetailParam"
    [customerId]="adjustmentDetail.customerId"
    (onEditorClose)="onAdjustmentEditorClose($event)"
></app-ar-adjustment-editor>
